import React from 'react';
import { Tooltip } from '@material-ui/core';
import {
  Container,
  ABwrapper,
  ABstatistics,
  ResendStats,
  ArrowUpIcon,
  Line,
  Column,
  Row,
  Resend,
  ArrowUpIconSmall,
  ArrowDownIconSmall,
  ArrowDownIcon,
  Title,
  Statistics,
  Divider,
  EmptySpace,
  AverageStats,
} from './CardABversion.styled';
import { generateAverage, getAverage } from '../../../utils';
import { DeliveryRateIcon } from '../../SVGs/Icons';
import { CANCELLED, SCHEDULED } from '../../constants';

const CardABversion = ({
  name,
  valueARatio,
  valueBRatio,
  smartResendValueARatio,
  smartResendValueBRatio,
  title,
  onClick = null,
  isSmartResendAvailable,
  showComparativeAnalytics,
  Icon,
  messageStatus,
  smartResendAverageCount,
  valueACount,
  valueBCount,
}) => {
  let averageResend = 0;
  const isNotZero = value => {
    return (
      value !== '' &&
      value !== '0%' &&
      value !== '0.0%' &&
      value !== 0 &&
      value !== null &&
      !String(value).includes('NaN%')
    );
  };

  if (smartResendValueARatio || smartResendValueBRatio) {
    averageResend = generateAverage(
      smartResendValueARatio || 0,
      smartResendValueBRatio || 0
    );
  }

  const isIncreasedInValue = val => {
    return val && !String(val).startsWith('-');
  };

  const renderIncrease = val => {
    return (
      <>
        <ArrowUpIcon />+{val} from resend ({smartResendAverageCount})
      </>
    );
  };

  const renderDecrease = val => {
    return (
      <>
        <ArrowDownIcon />
        {val} from resend
      </>
    );
  };

  const renderIncreaseSmall = val => {
    return (
      <>
        <ArrowUpIconSmall /> {val}
      </>
    );
  };

  const renderDecreaseSmall = val => {
    return (
      <>
        <ArrowDownIconSmall /> {val}
      </>
    );
  };

  const getStatFontSize = () => {
    if (messageStatus === CANCELLED || messageStatus === SCHEDULED) {
      return '20px';
    }
    return '34px';
  };

  const getStatValue = () => {
    if (messageStatus === CANCELLED) {
      return 'No data';
    }
    if (messageStatus === SCHEDULED) {
      return 'No data yet';
    }

    return generateAverage(valueARatio, valueBRatio);
  };

  const getAverageValue = () => {
    if (messageStatus === CANCELLED || messageStatus === SCHEDULED) {
      return null;
    }
    return getAverage(valueACount, valueBCount);
  };

  const shouldHideStats =
    messageStatus === CANCELLED || messageStatus === SCHEDULED;

  return (
    <Tooltip title={title} placement="top" style={{ justifyContent: 'center' }}>
      <Container onClick={onClick} width="130px">
        <Title>{name}</Title>
        <Row>
          {Icon ? <Icon /> : <DeliveryRateIcon />}
          <Statistics fontSize={getStatFontSize()}>{getStatValue()}</Statistics>
          <AverageStats>{getAverageValue()}</AverageStats>
        </Row>
        {isSmartResendAvailable && (
          <ResendStats>
            {isNotZero(averageResend) ? (
              showComparativeAnalytics ? (
                isIncreasedInValue(averageResend) ? (
                  renderIncrease(averageResend)
                ) : (
                  renderDecrease(averageResend)
                )
              ) : (
                <>
                  Resend: {averageResend} ({smartResendAverageCount})
                </>
              )
            ) : (
              'no change from resend'
            )}
          </ResendStats>
        )}
        {shouldHideStats ? (
          <EmptySpace />
        ) : (
          <>
            <Line />
            <ABwrapper>
              <Row>
                <Column>
                  <ABstatistics>
                    A: {valueARatio || '0.0%'} ({valueACount})
                  </ABstatistics>
                  {(isSmartResendAvailable &&
                    (isNotZero(smartResendValueARatio) ||
                      isNotZero(smartResendValueBRatio)) && (
                      <Resend>
                        {isNotZero(smartResendValueARatio) ? (
                          showComparativeAnalytics ? (
                            isIncreasedInValue(smartResendValueARatio) ? (
                              renderIncreaseSmall(smartResendValueARatio)
                            ) : (
                              renderDecreaseSmall(smartResendValueARatio)
                            )
                          ) : (
                            <>Resend: {smartResendValueARatio || '0.0%'}</>
                          )
                        ) : (
                          '- no change'
                        )}
                      </Resend>
                    )) ||
                    null}
                </Column>
                <Divider />
                <Column>
                  <ABstatistics>
                    B: {valueBRatio || '0.0%'} ({valueBCount})
                  </ABstatistics>
                  {(isSmartResendAvailable &&
                    (isNotZero(smartResendValueARatio) ||
                      isNotZero(smartResendValueBRatio)) && (
                      <Resend>
                        {isNotZero(smartResendValueBRatio) ? (
                          showComparativeAnalytics ? (
                            isIncreasedInValue(smartResendValueBRatio) ? (
                              renderIncreaseSmall(smartResendValueBRatio)
                            ) : (
                              renderDecreaseSmall(smartResendValueBRatio)
                            )
                          ) : (
                            <> Resend: {smartResendValueBRatio || '0.0%'}</>
                          )
                        ) : (
                          '- no change'
                        )}
                      </Resend>
                    )) ||
                    null}
                </Column>
              </Row>
            </ABwrapper>
          </>
        )}
      </Container>
    </Tooltip>
  );
};

export default CardABversion;
